module.exports = __webpack_public_path__ + "img/Rainbow.02bf98eb.png";